import { Box, IconButton, Text } from '@bitrise/bitkit';
import { PROJECT_TYPE_ICON_MAP } from '@/models/ProjectType';

import { App } from '@/models/App';
import BadgedAvatar from '@/components/BadgedAvatar/BadgedAvatar';

type AppTitleProps = {
  app: App;
  appSettingsPagePath: string;
  showAppSettingsButton: boolean;
};

const AppTitle = ({ app, appSettingsPagePath, showAppSettingsButton }: AppTitleProps) => {
  const titleAndAvatar = (
    <Box display="flex" alignItems="center" gap="16">
      <BadgedAvatar
        badgeIconName={PROJECT_TYPE_ICON_MAP[app.projectType || 'other']}
        name={app.title}
        variant="project"
        src={app.avatarUrl}
      />
      <Text as="h1" textStyle="heading/h1" hasEllipsis>
        {app.title}
      </Text>
    </Box>
  );

  return showAppSettingsButton ? (
    <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
      {titleAndAvatar}
      <IconButton
        as="a"
        aria-label="App settings"
        href={appSettingsPagePath}
        iconName="Settings"
        size="md"
        variant="secondary"
      />
    </Box>
  ) : (
    titleAndAvatar
  );
};

export default AppTitle;
